var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.925 10C18.925 14.9291 14.9291 18.925 10 18.925C5.07086 18.925 1.075 14.9291 1.075 10C1.075 5.07086 5.07086 1.075 10 1.075C14.9291 1.075 18.925 5.07086 18.925 10Z",
    stroke: "#333333",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97278 14.6531C10.256 14.6531 10.4839 14.5697 10.6565 14.4029C10.8291 14.2361 10.9154 14.0247 10.9154 13.7686C10.9154 13.5087 10.8272 13.2944 10.6507 13.1257C10.4742 12.9569 10.2482 12.8726 9.97278 12.8726C9.69736 12.8726 9.4714 12.9569 9.2949 13.1257C9.1184 13.2944 9.03015 13.5087 9.03015 13.7686C9.03015 14.0247 9.11646 14.2361 9.28908 14.4029C9.4617 14.5697 9.6896 14.6531 9.97278 14.6531Z",
    fill: "#393939"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 1.89,
    height: 7,
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.1db911dc07cd4da4eea9852c6a983fb8.svg";
export { ForwardRef as ReactComponent };